import { loadData } from './dataStore.js';

let cached = null;
let loading = null;

export function ensurePlayerIndex() {
  if (cached) return Promise.resolve(cached);
  if (loading) return loading;
  loading = loadData('playerIndex.json').then((d) => {
    cached = d;
    return cached;
  }).catch(() => { loading = null; return null; });
  return loading;
}
